import Book from "../custom/Icons/Book";
import Fulfilments from "../custom/Icons/Fulfilments";
import Person from "../custom/Icons/Person";
import Distributor from "../custom/Icons/Distributor";
import Settings from "../custom/Icons/Settings";
import SignOut from "../custom/Icons/SignOut";
import Windows from "../custom/Icons/Windows";

const routes = [
  {
    href: "/",
    icon: Windows,
    title: "Dashboard",
    mobile: true,
  },
  {
    href: "/books",
    icon: Book,
    title: "Books",
    mobile: true,
    children: [
      {
        href: "/books",
        title: "All books",
        mobile: true,
      },
      {
        href: "books/upload",
        title: "Upload Book",
        mobile: true,

        children: [
          {
            href: "/books",
            title: "All books",
            mobile: true,
          },
          {
            href: "books/uploadBook",
            title: "Upload Book",
            mobile: true,
          },
          {
            href: "/upgradePlan",
            title: "Upgrade your plan",
          },
        ],
      },
      {
        href: "/upgradePlan",
        title: "Upgrade your plan",
      },
    ],
  },
  {
    href: "/fulfilments",
    icon: Fulfilments,
    title: "Fulfillments",
    mobile: true,

    children: [
      {
        href: "/fulfilments",
        icon: Person,
        title: "Fulfillments",
      },
      {
        href: "/upgradePlan",
        title: "Upgrade your plan",
      },
    ],
  },
  {
    href: "/users",
    icon: Person,
    title: "Users",
    bottom: true,
    mobile: true,
    children: [
      {
        href: "/users",
        title: "List of users",
        mobile: true,
      },
      {
        href: "users/addUser",
        title: "Add user",
        mobile: true,
      },
    ],
  },
  {
    href: "/distributors",
    icon: Distributor,
    title: "Distributors",
    mobile: true,
  },
  {
    href: "/myAccount",
    icon: Settings,
    title: "My Account",
    bottom: true,
    mobile: true,
  },

  {
    href: "/logout",
    icon: SignOut,
    title: "Sign out",
    bottom: true,
    mobile: true,
  },

  // {
  //   href: "/baseComponents",
  //   icon: Person,
  //   title: "Base Components",
  // },
  // {
  //   href: "/complexComponents",
  //   icon: Person,
  //   title: "Complex Components",
  // },
  // {
  //   href: "/upgradePlan",
  //   icon: Person,
  //   title: "Upgrade your plan",
  // },
];

const navItems = [
  {
    pages: routes,
  },
];

export default navItems;
